import mapActions from "actions/map";
import modalActions from "actions/modal";
import MainMap from "components/map/mainMap";
import { dateTimeToView } from "helpers/date";
import { divIcon } from "leaflet";
import compact from "lodash/compact";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RouteView from "./routeView";

class RouteMap extends MainMap {
    componentDidMount() {
        const bounds = this.props.data.bidPoints.map((bidPoint) =>
            [...bidPoint.geozone.location.coordinates].reverse(),
        );

        const notNullPoints = [...compact(bounds)];
        setTimeout(() => {
            if (notNullPoints.length && this.map) {
                this.map.fitBounds(notNullPoints, { maxZoom: 10, padding: [50, 50] });
            }
        }, 0);
    }

    componentDidUpdate() {
        return undefined;
    }

    UNSAFE_componentWillReceiveProps() {
        return undefined;
    }

    renderFixRouteBidBtn = () => null;
    renderCheckRegistryPointsBtn = () => null;
    renderRequireForwardingOrderBtn = () => null;
    renderBidDataLegend = () => null;

    renderRoute = () => {
        const { currentBid, route, carRoutes, bidPoints } = this.props.data;
        if (currentBid && route) {
            let carCoords = [];
            let routePoints = {};
            if (carRoutes) {
                [carCoords, routePoints] = this.carCoords(carRoutes);
            }
            const { zoom } = this.props.viewport;
            return (
                <RouteView
                    route={route}
                    traveledRoute={carCoords}
                    routePoints={routePoints}
                    bidId={currentBid}
                    bidPoints={bidPoints}
                    organizationTimezone={this.props.organizationTimezone}
                    filters={this.state.bidFilters}
                    zoom={zoom}
                    mergeMapData={this.props.mergeMapData}
                />
            );
        }
        return null;
    };

    renderBidCarLocation = () => {
        const { lastCarLocation, estimation, car } = this.props.data;

        return (
            <>
                {!!lastCarLocation && (
                    <Marker
                        {...{
                            position: [...lastCarLocation.coordinate].reverse(),
                            icon: divIcon({
                                iconSize: [28, 82],
                                className: "map__icon map-icon map-icon--blue-track map-icon--car",
                            }),
                        }}
                    >
                        <Tooltip permanent className="map__tooltip" direction="top">
                            <div className="font-weight-semibold">{car.number}</div>
                            <div>
                                <span className="">Синхронизация GPS:</span> <br />
                                <small>{dateTimeToView(lastCarLocation.fixedAt, "DD.MM.YYYY HH:mm (Z)")}</small>
                            </div>
                        </Tooltip>
                    </Marker>
                )}
                {!!estimation?.estimatedLocation && (
                    <Marker
                        position={[...estimation.estimatedLocation.coordinate].reverse()}
                        zIndexOffset={-50}
                        icon={divIcon({
                            iconSize: [28, 82],
                            className: "map__icon map-icon map-icon--blue-track map-icon--car map-icon--blue",
                        })}
                    >
                        <Tooltip className="map__tooltip" direction="top">
                            <div>Плановая точка нахождения машины</div>
                            {estimation.estimatedLocation.fixedAt && (
                                <div>
                                    Дата последнего расчета:{" "}
                                    {dateTimeToView(estimation.estimatedLocation.fixedAt, "DD.MM.YYYY HH:mm (Z)")}
                                </div>
                            )}
                        </Tooltip>
                    </Marker>
                )}
            </>
        );
    };

    renderBody = () => {
        return (
            <>
                {this.renderCarMarkers()}
                {this.renderBidCarLocation()}
                {this.renderRoutePoints()}
                {this.renderRoute()}
                {this.renderItemChangePoints()}
                {/* {this.renderBidItemsChanges()} */}
                {this.renderPostamats()}
                {this.renderUnstableZones()}
                {this.renderPlatonPoints()}
                {this.renderPaymentPoints()}
                {this.renderEmergencyAreaPoints()}
                {this.renderRoadRestrictions()}
                {this.renderBidRoadRestrictions()}
            </>
        );
    };
}

const mapStateToProps = (state) => ({
    mode: state.map.mode,
    viewport: state.map.viewport,
    fullscreen: state.layout.fullscreen,
    tileUrls: state.configs.tileUrls,
    params: state.map.params,
    organizationTimezone: state.profile.timezone,
    organization: state.profile.organization,
    roles: state.profile.roles,
    enums: state.dictionaries.enums,
    profile: state.profile.profile,
    header: state.map.header,
    platonPoints: state.map.platonPoints,
    postamatPoints: state.map.postamatPoints,
    paymentPoints: state.map.paymentPoints,
    roadRestrictions: state.map.roadRestrictions,
    roadRestrictionTypes: state.map.roadRestrictionTypes,
    // regionDryingPeriods: state.map.regionDryingPeriods,
});

const mapDispatchToProps = (dispatch) => ({
    switchMap: (params) => dispatch(mapActions.switchMap(params)),
    mergeMapViewport: (params) => dispatch(mapActions.mergeMapViewport(params)),
    mergeMapData: (params) => dispatch(mapActions.mergeMapData(params)),
    changeCenter: (params) => dispatch(mapActions.changeCenter(params)),
    mergeParams: (params) => dispatch(mapActions.mergeParams(params)),
    modal: (params) => dispatch(modalActions.open(params)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RouteMap));
